const marsQuiz = [
  {
    question: "Mars dikenal dengan sebutan apa?",
    options: ["Planet Biru", "Planet Merah", "Planet Raksasa", "Planet Es"],
    answer: 1,
  },
  {
    question: "Mengapa Mars terlihat berwarna merah?",
    options: [
      "Karena lava",
      "Karena pasir emas",
      "Karena debu besi",
      "Karena cahaya Matahari",
    ],
    answer: 2,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Mars?",
    options: ["1", "2", "3", "4"],
    answer: 1,
  },
  {
    question: "Apa nama bulan Mars?",
    options: [
      "Io dan Europa",
      "Titan dan Enceladus",
      "Phobos dan Deimos",
      "Luna dan Solar",
    ],
    answer: 2,
  },
  {
    question: "Gunung terbesar di Mars bernama?",
    options: [
      "Mount Everest",
      "Olympus Mons",
      "Mauna Kea",
      "Red Peak",
    ],
    answer: 1,
  },
  {
    question: "Apakah Mars lebih dingin atau lebih panas dari Bumi?",
    options: [
      "Lebih panas",
      "Lebih dingin",
      "Sama saja",
      "Tidak bisa diukur",
    ],
    answer: 1,
  },
  {
    question: "Mars berada di urutan ke berapa dari Matahari?",
    options: ["2", "3", "4", "5"],
    answer: 2,
  },
  {
    question: "Mengapa Mars sering diteliti ilmuwan?",
    options: [
      "Karena ada dinosaurus",
      "Karena pernah ada air",
      "Karena dekat Matahari",
      "Karena sangat panas",
    ],
    answer: 1,
  },
  {
    question: "Udara di Mars bagaimana?",
    options: [
      "Sangat tebal",
      "Sama seperti Bumi",
      "Sangat tipis",
      "Tidak ada sama sekali",
    ],
    answer: 2,
  },
  {
    question: "Siapa yang paling tertarik menjelajahi Mars?",
    options: [
      "Penyanyi",
      "Pelukis",
      "Ilmuwan dan astronot",
      "Atlet",
    ],
    answer: 2,
  },
];

export default marsQuiz;